import { Person } from "@sentara-health/sentara-api-hooks-core";

export const toPascalCase = (str: string): string => {
  if (!str) {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const capitalizeWords = (str: string): string => {
  if (!str.trim()) {
    return "";
  }

  return str
    .split(" ")
    .map((word: string) => toPascalCase(word))
    .join(" ");
};

export const formatName = (
  firstName?: string,
  middleName?: string,
  lastName?: string
): string => {
  const fullName = [firstName ?? "", middleName ?? "", lastName ?? ""]
    .filter(Boolean)
    .join(" ");

  return capitalizeWords(fullName).trim();
};

export const formatPersonName = (person?: Person): string => {
  if (!person) {
    return "";
  }
  const { firstName, middleName, lastName } = person;
  return formatName(firstName, middleName, lastName);
};
